var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Editoras e produtoras","titleIcon":"fas fa-industry"}},[_c('catalogo-crud',{attrs:{"tipo":"editora","rotuloNovo":"NOVA EDITORA","nomeSingular":"registro","placeholderBusca":"Pesquisar por nome ou cidade","campos":_vm.campos,"colunas":_vm.colunas,"filtroExtra":_vm.filtroExtra}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }